import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateBookingStatus } from 'repositories/BerthApi/updateBookingStatus'
import { berthKeys } from 'repositories/queryKeys'

export function useUpdateBookingStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateBookingStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: berthKeys.managements() })
    },
  })
}
